import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoArrowRight, LazySvgoExternalLink, LazySvgoLocation, LazySvgoLogo, LazySvgoPrismDots } from '#components'
const lazyGlobalComponents = [
  ["SvgoArrowRight", LazySvgoArrowRight],
["SvgoExternalLink", LazySvgoExternalLink],
["SvgoLocation", LazySvgoLocation],
["SvgoLogo", LazySvgoLogo],
["SvgoPrismDots", LazySvgoPrismDots],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
